<template>
  <div>
      <section class="section is-medium">
    <div class="container">
      
      
      <div class="columns is-centered">
        <div class="column is-8">
          <div class="content is-medium">
            <h1>Frequently Asked Questions (FAQ)</h1>
<h2 id="one-form-per-email-sent-vs-one-form-per-newsletter">Correct Use: One Form per Email Sent vs One Form per Newsletter</h2>

<p>I got asked a couple of times now how to use FeedLetter - is it one form per email or one form per newsletter.</p>

<p>The intended use was one form per email you send out. So, if you write twice a week, you create 2 forms a week, for each email one.</p>

<p><strong>Why?</strong> Because you get feedback on the individual emails and learn which topics work and which not. Also, the extended feedback is more specific. The UI is designed for that with the least clicks possible :-)</p>

<p><strong>However</strong>, I know a couple of customers use it differently with only one form per newsletter. They still get their insights from votes and extended feedback.</p>

<p>I focus development on the intended use but will not force you to use it. If the other way works for you, go with it. I&#39;ll even support that way as much as possible without breaking the experience. Why? Because it&#39;s about you and I want you to get the most out of FeedLetter.</p>

<h2 id="how-do-i-know-who-downvoted">How Do I Know Who Downvoted?</h2>

<p>It&#39;s tempting to know who downvoted or dislikes your emails but know it might not help you at all. If people don&#39;t tell you via an anonymous form, something they feel safe, they won&#39;t tell you when you email them.</p>

<p>FeedLetter is driven by privacy, and I do not track your or my readers. And readers love that. They can tell you and me anonymously what they liked or disliked and why. And some of them even tell you who they are by filling out the optional name field on the extended feedback page.</p>

<p>Some even go so far and give you their email address in the comment field. So, if they really want to tell you who they are, they will do it. Either via FeedLetter or simply by sending you an email.</p>

<p>You could try to track them via your email provider&#39;s analytics, but that has some flaws as those analytics cannot track everyone. And no, they don&#39;t send along with an external link who clicked on it. So, FeedLetter has no way to know which user it was.</p>

<p>Anyway, I encourage you to experiment with the wording to get them to tell you their reasons. It&#39;s all about trust, feeling safe, and genuinely being heard.</p>

<p>You can customize all reader facing text.</p>

<h2 id="stats-differ-esp-fl">Why Are There Difference Between The Click Counts In My Newsletter Provider And Feedletter?</h2>
<p>There are a few reasons how those discrepancies happen.</p>
<p>It starts already at the newsletter provider level there because the tracking on the newsletter providers&#39; level is already flawed aka not perfect. There&#39;re certain conditions, of course, with differences from provider to provider, because of the way those clicks are counted.</p>
<p>Also, they don&#39;t differentiate between actual clicks by the user or by an in-between system. I learned that in the early stages of FeedLetter with my mail providers mailerLite &amp; mailchimp, for example, some users always had click records in mailerLite for ALL my voting links. Turned out some server checked all links before delivering the email to the user&#39;s inbox. Or with Mailchimp, where an automated process opened the links and caused votes in FeedLetter even the user hadn&#39;t triggered anything yet.</p>
<p>Then there’re other situations where differences can come from:</p>
<ol>
<li>Reader clicks in your email, i.e. ConvertKit or Substack, track the click but before the feedback page loads, they click the back button. Click in e.g. Convertkit but not necessary in FeedLetter. Depends on how quick it was and if the vote call could be made.</li>
<li>Double vote protection in FeedLetter. If the reader votes once, she can&#39;t vote for the same survey and rating again from the same device, e.g. if she clicks 3 times in e.g. ConvertKit to the FeedLetter link, only 1 vote is registered in FeedLetter. As FeedLetter is anonymous, I don&#39;t track the reader while newsletter providers can.</li>
<li>Bot and foreign systems detection. There&#39;re plenty of bots and other systems that process emails, like spam checkers, virus checkers and other tools people use to process emails automatically. These tools do follow links and would follow the voting links and thus vote. To prevent such systems from falsifying the results in FeedLetter, a bot detection system is in place that doesn&#39;t count the votes of bots and systems. </li>
</ol>
<p>As a constant counter measure, I block for example all known IP ranges of AWS, Google Cloud or Azure and now certain Office 365 Outlook servers. Those are all votes from other SaaS &amp; tools but never from a user.</p>
<p>However, I’ve never seen the ESP to block them in click tracking so they still count there. Only there own tools are removed from their click counting. No other systems.</p>
<p>The Ip blocking bot detection was introduced around July 2022 and I updated it twice recently with the major change of adding Office 365 Outlook &quot;protection&quot; servers.</p>

          </div>
        </div>
      </div>
    </div>
  </section>
  </div>
</template>

<script>
export default {
  name: "faq",
  data: function () {
    return {

    };
  },
  mounted: function () {
      if (window.location.hash && window.location.hash.includes("stats-differ-esp-fl")) {
        document.getElementById("stats-differ-esp-fl").scrollIntoView();
      }
  },
  methods: {
    
  },
};
</script>

